import { SiteModel } from "../models/site.model";
import { RegionModel } from "../models/region.model";
import { FilterModel } from "../models/filter.model";
import { ModuleModel } from "../models/module.model";
import { ServerModel } from "../models/server.model";
import { CheckpointServerModel } from "../models/checkpoint-server.model";
import { SensorModel } from "../models/sensor.model";
import { UserModel } from "../models/user.model";
import { CongestionModel } from "../models/congestion.model";
import { GsmSensorModel } from "../models/gsm-sensor-model";
import { CaptivePortalModel, Content } from "../models/captive-portal.model";
import { ProfileModel } from "../models/profile.model";
import { FixedSizeVirtualScrollStrategy } from "@angular/cdk/scrolling";

export class DataService {
  public _associatedRegions: Array<RegionModel>;
  public _regions: RegionModel[] = [];
  public _selectedSite: SiteModel;
  public _selectedSensor: SensorModel;
  public _selectedRegion: RegionModel;
  public _selectedCongestion: CongestionModel;
  public _selectedAssociatedRegion: RegionModel;
  public _regionUpdated: boolean = false;
  public _selectedFilter: FilterModel;
  public _selectedModule: ModuleModel;
  public _selectedServer: ServerModel;
  public _selectedCheckpointServer: CheckpointServerModel;
  public _selectedUser: UserModel;
  public _serverToFilter: number;
  public sitesToExclude: SiteModel[];
  public _selectedCaptivePortal: Content;
  public _selectedProfile: ProfileModel;
  public _virtualRegion: boolean = false;

  get associatedRegions(): RegionModel[] {
    if (
      this._associatedRegions === undefined ||
      this._associatedRegions === []
    ) {
      this._associatedRegions = JSON.parse(
        window.localStorage.getItem("associatedRegions")
      );
    }
    return this._associatedRegions;
  }

  set associatedRegions(value: RegionModel[]) {
    this._associatedRegions = value;
    window.localStorage.setItem("associatedRegions", JSON.stringify(value));
  }

  get regions(): RegionModel[] {
    if (this._regions === undefined || this._regions === []) {
      this._regions = JSON.parse(window.localStorage.getItem("regions"));
    }
    return this._regions;
  }

  set regions(value: RegionModel[]) {
    this._regions = value;
    window.localStorage.setItem("regions", JSON.stringify(value));
  }

  get selectedUser(): UserModel {
    if (this._selectedUser === undefined) {
      this._selectedUser = JSON.parse(
        window.localStorage.getItem("selectedUser")
      );
    }
    return this._selectedUser;
  }

  set selectedUser(value: UserModel) {
    this._selectedUser = value;
    window.localStorage.setItem("selectedUser", JSON.stringify(value));
  }

  get selectedSite(): SiteModel {
    if (this._selectedSite === undefined) {
      this._selectedSite = JSON.parse(
        window.localStorage.getItem("selectedSite")
      );
    }
    return this._selectedSite;
  }

  set selectedSite(value: SiteModel) {
    this._selectedSite = value;
    window.localStorage.setItem("selectedSite", JSON.stringify(value));
  }

  get selectedSensor(): SensorModel {
    if (this._selectedSensor === undefined) {
      this._selectedSensor = JSON.parse(
        window.localStorage.getItem("selectedSensor")
      );
    }
    return this._selectedSensor;
  }

  set selectedSensor(value: SensorModel) {
    this._selectedSensor = value;
    window.localStorage.setItem("selectedSensor", JSON.stringify(value));
  }

  get selectedCaptivePortal(): Content {
    if (this._selectedCaptivePortal === undefined) {
      this._selectedCaptivePortal = JSON.parse(
        window.localStorage.getItem("selectedCaptivePortal")
      );
    }
    return this._selectedCaptivePortal;
  }

  set selectedCaptivePortal(value: Content) {
    this._selectedCaptivePortal = value;
    window.localStorage.setItem("selectedCaptivePortal", JSON.stringify(value));
  }

  get selectedRegion(): RegionModel {
    if (this._selectedRegion === undefined) {
      this._selectedRegion = JSON.parse(
        window.localStorage.getItem("selectedRegion")
      );
    }
    return this._selectedRegion;
  }

  set selectedRegion(value: RegionModel) {
    this._selectedRegion = value;
    window.localStorage.setItem("selectedRegion", JSON.stringify(value));
  }

  get selectedCongestion(): CongestionModel {
    if (this._selectedCongestion === undefined) {
      this._selectedCongestion = JSON.parse(
        window.localStorage.getItem("selectedCongestion")
      );
    }
    return this._selectedCongestion;
  }

  set selectedCongestion(value: CongestionModel) {
    this._selectedCongestion = value;
    window.localStorage.setItem("selectedCongestion", JSON.stringify(value));
  }

  get selectedAssociatedRegion(): RegionModel {
    if (this._selectedAssociatedRegion === undefined) {
      this._selectedAssociatedRegion = JSON.parse(
        window.localStorage.getItem("selectedAssociatedRegion")
      );
    }
    return this._selectedAssociatedRegion;
  }

  set selectedAssociatedRegion(value: RegionModel) {
    this._selectedAssociatedRegion = value;
    window.localStorage.setItem(
      "selectedAssociatedRegion",
      JSON.stringify(value)
    );
  }

  get regionUpdated(): boolean {
    this._regionUpdated = JSON.parse(
      window.localStorage.getItem("regionUpdated")
    );
    return this._regionUpdated;
  }

  set regionUpdated(value: boolean) {
    this._regionUpdated = value;
    window.localStorage.setItem("regionUpdated", JSON.stringify(value));
  }

  get selectedFilter(): FilterModel {
    if (this._selectedFilter === undefined) {
      this._selectedFilter = JSON.parse(
        window.localStorage.getItem("selectedFilter")
      );
    }
    return this._selectedFilter;
  }

  set selectedFilter(value: FilterModel) {
    this._selectedFilter = value;
    window.localStorage.setItem("selectedFilter", JSON.stringify(value));
  }

  get selectedModule(): ModuleModel {
    if (this._selectedModule === undefined) {
      this._selectedModule = JSON.parse(
        window.localStorage.getItem("selectedModule")
      );
    }
    return this._selectedModule;
  }

  set selectedModule(value: ModuleModel) {
    this._selectedModule = value;
    window.localStorage.setItem("selectedModule", JSON.stringify(value));
  }

  get selectedServer(): ServerModel {
    if (this._selectedServer === undefined) {
      this._selectedServer = JSON.parse(
        window.localStorage.getItem("selectedServer")
      );
    }
    return this._selectedServer;
  }

  set selectedServer(value: ServerModel) {
    this._selectedServer = value;
    window.localStorage.setItem("selectedServer", JSON.stringify(value));
  }

  get selectedCheckpointServer(): CheckpointServerModel {
    if (this._selectedCheckpointServer === undefined) {
      this._selectedCheckpointServer = JSON.parse(
        window.localStorage.getItem("selectedCheckpointServer")
      );
    }
    return this._selectedCheckpointServer;
  }

  set selectedCheckpointServer(value: CheckpointServerModel) {
    this._selectedCheckpointServer = value;
    window.localStorage.setItem("selectedCheckpointServer", JSON.stringify(value));
  }

  get selectedProfile(): ProfileModel {
    if (this._selectedProfile === undefined) {
      this._selectedProfile = JSON.parse(
        window.localStorage.getItem("selectedProfile")
      );
    }
    return this._selectedProfile;
  }

  set selectedProfile(value: ProfileModel) {
    this._selectedProfile = value;
    window.localStorage.setItem("selectedProfile", JSON.stringify(value));
  }

  get serverToFilter(): number {
    if (this._serverToFilter === undefined) {
      this._serverToFilter = JSON.parse(
        window.localStorage.getItem("serverToFilter")
      );
    }
    return this._serverToFilter;
  }

  set serverToFilter(value: number) {
    this._serverToFilter = value;
    window.localStorage.setItem("serverToFilter", JSON.stringify(value));
  }
  get virtualRegion(): boolean {
    this._virtualRegion = JSON.parse(
      window.localStorage.getItem("virtualRegion")
    );
    return this._virtualRegion;
  }

  set virtualRegion(value: boolean) {
    this._virtualRegion = value;
    window.localStorage.setItem("virtualRegion", JSON.stringify(value));
  }
}
